import { RouteConfig } from 'vue-router';
import Login from '@/views/pos/authenticate/Login.vue';

const publicRoutes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Login',
    component: Login
  }
];

export default publicRoutes;
